module.exports = __webpack_public_path__ + "img/Just-30-Days-Guarantee.e11a3221.jpg";